import React from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import PlayerExposureSummary from 'components/organisms/used-players-list/components/player-exposure-summary';
import TeamLogo from 'components/molecules/team-logo';
import RankPlayerExclusionState from 'components/molecules/player-exclusion/rank-player-exclusion-state';
import FilterLineupsByPlayerAndMode from 'components/molecules/filter-lineups-by-player/filter-lineups-by-player-and-mode';
import PlayerInjury from 'components/molecules/player-injury';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;

        const filteredPlayers = this.getFilteredUsedPlayers();

        if (isEmpty(filteredPlayers)) {
            return [];
        }

        let players = [];
        if (Const.PLAYERS_SHOWDOWN_FILTER_ALL === filters.showDown) {
            let assocList = {};
            filteredPlayers.map((player) => {
                if (!assocList.hasOwnProperty(player.playerId)) {
                    assocList[player.playerId] = {...player};
                    assocList[player.playerId].setAsCaptain();
                } else {
                    assocList[player.playerId].usedLineupsCount += player.usedLineupsCount;
                }
            });
            players = Object.values(assocList);
        } else {
            let searchParams = {};
            const lineupRoles = [Const.CAPTAIN_MODE];
            if (inArray(filters.showDown, lineupRoles)) {
                searchParams = {
                    lineupRole: {
                        filterType: Const.FILTER_TYPE_EQUAL,
                        filterValue: filters.showDown,
                    },
                };
            } else {
                searchParams = {
                    lineupRole: {
                        filterType: Const.FILTER_TYPE_NOT_IN_ARRAY,
                        filterValue: lineupRoles,
                    },
                };
            }
            players = filterObjectByParams(filteredPlayers, searchParams, true);
        }

        players = sortArrayOfObjects(players, 'usedLineupsCount', 'desc');

        return players;
    }

    render() {
        const {sportConfig, filters} = this.props;
        const players = this.getPlayers();
        const renderKey = this.getRenderKey();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tr key={`${renderKey}${index}`} className={`${className} ${this.getRowClassName(player)}`}>
                        <td className="check">
                            <RankPlayerExclusionState
                                activeMode={filters.showDown}
                                playerMode={filters.showDown}
                                playerId={player.getId()}
                            />
                        </td>
                        <td>
                            <FilterLineupsByPlayerAndMode player={player} activeMode={filters.showDown} />
                        </td>
                        <td className="name">
                            {player.name}
                            <PlayerInjury player={player} />
                        </td>
                        <td>{player.positionName}</td>
                        <td className="td-team">
                            <TeamLogo teamName={player.team} />
                        </td>
                        <td>
                            {this.wrapContentInTooltip(
                                <PlayerPoints
                                    className="form-control xs-table-input"
                                    playerId={player.getId()}
                                    mode={filters.showDown}
                                    propName={'userPoints'}
                                />,
                                `Default Score: ${player.getPropValueOfMode('adminPoints', filters.showDown)}`,
                            )}
                        </td>
                        {this.getPlayerExposureView(player)}
                        <td>{player.projOwn.getValue(filters.showDown)}</td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMin'}
                                    mode={filters.showDown}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMax'}
                                    mode={filters.showDown}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                    </tr>,
                );

                if (Const.PLAYERS_SHOWDOWN_FILTER_ALL === filters.showDown) {
                    items.push(
                        <tr
                            key={`${renderKey}${index}-1`}
                            className={`top-line ${className} ${this.getRowClassName(player)}`}
                        >
                            <td colSpan="10">
                                <PlayerExposureSummary
                                    sport={sportConfig.getSport()}
                                    site={sportConfig.getSite()}
                                    gameType={Const.GAME_TYPE_SHOWDOWN}
                                    playerId={player.getId()}
                                />
                            </td>
                        </tr>,
                    );
                }
            });
        } else {
            items.push(this.getPlayersNotFoundView({colSpan: 9}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="table-scroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Name</th>
                                <th>Pos</th>
                                <th className="td-team">Team</th>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>pOwn%</th>
                                <th>
                                    Exp.
                                    <br />
                                    min
                                </th>
                                <th>
                                    Exp.
                                    <br />
                                    max
                                </th>
                            </tr>
                        </thead>
                        <tbody>{items}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
        playersData: {games},
    } = state;

    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
        games,
    };
}

const PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
